import React, { forwardRef, JSX, Ref } from 'react';
import { DataTestIdProp } from '../../../../Models/DataTestIdProp';
import { Button } from 'reactstrap';
import DateDisplay from '../../UI/DateDisplay/DateDisplay';
import { Nbsp } from '../../UI/Nbsp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { Theme } from '@emotion/react';
import { OnChangeDate } from './DateWithKeyboardSupport';

export interface CustomDisplayProps {
  date?: Date;
  format?: string;
  onClick?: () => void;
  theme?: Theme;
  placeholder?: string;
  className?: string;
  onInputChange?: (date: OnChangeDate | null, error?: boolean) => void;
  minDate?: Date | null | undefined;
  maxDate?: Date | null | undefined;
  inputClassName?: string | undefined;
  useFormValidation?: boolean | undefined;
  setValueToNullWhenFormatIsIncorrect?: boolean;
  noInitialValueInput?: boolean;
}

const CustomDateDisplayInner = (
  props: CustomDisplayProps & DataTestIdProp,
  ref: Ref<Button>
): JSX.Element => {
  const { onClick, date, format, placeholder, dataTestId, className } = props;
  return (
    <Button
      className={`iso__date-range-input custom-button ${className || ''}`}
      color="white"
      onClick={onClick}
      ref={ref}
      data-testid={dataTestId}
    >
      <div className="d-flex">
        {date ? (
          <div className="w-100">
            <DateDisplay date={date.toISOString()} format={format} />
          </div>
        ) : (
          <Nbsp />
        )}
        {props.theme?.useCalenderIcon && (
          <div className="ml-auto">
            <FontAwesomeIcon icon={faCalendarAlt} />
          </div>
        )}
        {!date && placeholder ? (
          <div className="w-100 text-left text-muted">{placeholder}</div>
        ) : (
          <Nbsp />
        )}
      </div>
    </Button>
  );
};

export const CustomDateDisplay = forwardRef(CustomDateDisplayInner) as (
  props: CustomDisplayProps & DataTestIdProp,
  ref: Ref<Button>
) => ReturnType<typeof CustomDateDisplayInner>;
